// InscripcionCard.js - Resumen de una inscripción a evento (Mis eventos y formulario ya enviado)
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { processFlowPayment } from '../../services/paymentsService';
import { formatFechaLarga } from '../../utils/fechas';

const MODALIDAD = { raw: 'Raw', classic_raw: 'Classic Raw', single_ply: 'Single Ply', equipado: 'Equipado', bench: 'Solo banca', deadlift: 'Solo peso muerto' };
const EXTRA = { bench: 'Banca', deadlift: 'Peso muerto' };
const EDAD = { sub_junior: 'Sub-Junior', subjunior: 'Sub-Junior', junior: 'Junior', open: 'Open', master: 'Master' };

const COLORES = {
  confirmado: { fondo: '#e8f5e9', texto: '#2e7d32' },
  completado: { fondo: '#e3f2fd', texto: '#1565c0' },
  inscrito: { fondo: '#fff3e0', texto: '#b26a00' },
  cancelado: { fondo: '#ffebee', texto: '#c62828' },
  descalificado: { fondo: '#ffebee', texto: '#c62828' },
};

const lista = (valor, mapa) => String(valor || '')
  .split(',')
  .map((v) => v.trim().toLowerCase())
  .filter((v) => v && v !== 'no')
  .map((v) => mapa[v] || v)
  .join(' + ');

const formatoCLP = (n) => (n == null || n === '' ? null : `$${Math.round(Number(n)).toLocaleString('es-CL')}`);

const InscripcionCard = ({ inscripcion, mostrarEvento = true }) => {
  const [pagando, setPagando] = useState(false);
  const [error, setError] = useState('');
  const ev = inscripcion.evento || {};
  const color = COLORES[inscripcion.estado] || COLORES.inscrito;

  const fechas = ev.fecha_inicio
    ? (ev.fecha_fin && ev.fecha_fin !== ev.fecha_inicio
      ? `${formatFechaLarga(ev.fecha_inicio)} al ${formatFechaLarga(ev.fecha_fin)}`
      : formatFechaLarga(ev.fecha_inicio))
    : null;

  const detalles = [
    ['División', inscripcion.division ? (inscripcion.division === 'UNTESTED' ? 'Untested' : 'Tested') : null],
    ['Categoría de peso', inscripcion.categoria_peso],
    ['Modalidad', [MODALIDAD[String(inscripcion.modalidad || '').toLowerCase()] || inscripcion.modalidad, lista(inscripcion.modalidad_extra, EXTRA)].filter(Boolean).join(' + ')],
    ['División de edad', [lista(inscripcion.division_edad, EDAD), lista(inscripcion.division_edad_extra, EDAD)].filter(Boolean).join(' + ')],
    ['Día / tanda', [inscripcion.dia_salida && `Día ${inscripcion.dia_salida}`, inscripcion.tanda && `Tanda ${String(inscripcion.tanda).toUpperCase()}`].filter(Boolean).join(' · ')],
    ['Monto', formatoCLP(inscripcion.monto)],
  ].filter(([, v]) => v);

  const completarPago = async () => {
    setPagando(true);
    setError('');
    try {
      let email;
      try { email = JSON.parse(localStorage.getItem('user') || '{}').email; } catch { email = undefined; }
      const { payment_url } = await processFlowPayment({
        orderId: inscripcion.order_id,
        amount: inscripcion.monto,
        email,
        subject: `Inscripción evento: ${ev.nombre || ev.id}`,
      });
      window.location.href = payment_url;
    } catch (e) {
      setError(e.message || 'No se pudo iniciar el pago');
      setPagando(false);
    }
  };

  return (
    <article className="insc-card">
      {mostrarEvento && (
        <div className="insc-poster">
          {ev.imagen_url ? <img src={ev.imagen_url} alt={`Afiche ${ev.nombre}`} loading="lazy" /> : <span className="ach-display">{String(ev.nombre || '?').charAt(0)}</span>}
        </div>
      )}
      <div className="insc-body">
        <div className="insc-head">
          {mostrarEvento && <h3 className="insc-title">{ev.nombre}</h3>}
          <span className="insc-estado" style={{ background: color.fondo, color: color.texto }}>
            {inscripcion.estado_legible || inscripcion.estado}
          </span>
        </div>
        {mostrarEvento && (fechas || ev.ciudad) && (
          <p className="insc-meta">{[fechas, [ev.ciudad, ev.region].filter(Boolean).join(', ')].filter(Boolean).join(' · ')}</p>
        )}
        <dl className="insc-detalles">
          {detalles.map(([k, v]) => (
            <div key={k}><dt>{k}</dt><dd>{v}</dd></div>
          ))}
        </dl>
        {inscripcion.pago_pendiente && (
          <div className="insc-pago">
            <span>Tu inscripción queda confirmada al completar el pago.</span>
            {inscripcion.monto ? (
              <button type="button" className="ach-pill ach-pill--red ach-pill--sm" onClick={completarPago} disabled={pagando}>
                {pagando ? 'Redirigiendo…' : `Completar pago ${formatoCLP(inscripcion.monto)}`}
              </button>
            ) : (
              <span>Escríbenos para completar el pago.</span>
            )}
          </div>
        )}
        {error && <p className="insc-error" role="alert">{error}</p>}
        {mostrarEvento && ev.id && (
          <Link className="insc-link" to="/events">Ver eventos →</Link>
        )}
      </div>
    </article>
  );
};

export default InscripcionCard;
